import type { Route } from '@angular/router';

import {
  adminGuard,
  authGuard,
  requireCustomerProfile,
  tokenResolver
} from '@asset-solutions/customer-portal/auth/data-access';
import {
  ChangePasswordComponent,
  ForgotPasswordComponent,
  LoginComponent,
  RegisterUserComponent,
  ResetPasswordComponent,
  alreadyAuthenticatedGuard
} from '@asset-solutions/customer-portal/auth/feature-main';
import { MainComponent } from '@asset-solutions/customer-portal/orders/feature-main';

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [alreadyAuthenticatedGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    resolve: { temporarySession: tokenResolver }
  },
  {
    path: 'register',
    component: RegisterUserComponent,
    resolve: { temporarySession: tokenResolver }
  },
  {
    path: 'live-map',
    loadChildren: () => import('@asset-solutions/customer-portal/live-map').then((m) => m.liveMapRoutes),
    canActivate: [authGuard]
  },
  {
    path: 'alerts',
    loadChildren: () => import('@asset-solutions/customer-portal/alerts').then((m) => m.alertRoutes),
    canActivate: [authGuard, requireCustomerProfile]
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [authGuard]
  },
  {
    path: 'user-management',
    loadChildren: () =>
      import('@asset-solutions/customer-portal/user-management/feature-main').then((m) => m.userManagementRoutes),
    canActivate: [authGuard, requireCustomerProfile]
  },
  {
    path: 'billing',
    loadChildren: () => import('@asset-solutions/customer-portal/billing').then((m) => m.BillingRoutes),
    canActivate: [authGuard, adminGuard, requireCustomerProfile]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [authGuard]
  },
  {
    path: 'order/:orderMasterId',
    outlet: 'details',
    loadChildren: () =>
      import('@asset-solutions/customer-portal/orders/feature-details').then((m) => m.orderDetailsRoutes),
    canActivate: [authGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
